export const TextField = theme => {
  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          "&:has([readonly]) ": {
            "& .MuiInputBase-readOnly": {
              backgroundColor: "#fffacd",
            },
          },
        },
      },
    },
  }
}
